import styled from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { createReadableClass } from '@elfsight/widget-utils';
import { commonFieldsSettings } from '../commonFieldSettings';

export interface ParagraphProps {
  text: string;
  fieldFontStyle?: TextStyleValue;
  fieldColor?: string;
}

export function Paragraph({
  text,
  fieldFontStyle = commonFieldsSettings.fieldFontStyle,
  fieldColor = commonFieldsSettings.fieldColor
}: ParagraphProps) {
  return (
    <ParagraphControl
      dangerouslySetInnerHTML={{ __html: text }}
      _fontSize={fieldFontStyle.fontSize}
      _color={fieldColor}
    />
  );
}

interface ParagraphControlProps {
  _fontSize: number;
  _color: string;
}

const ParagraphControl = styled.div.attrs<ParagraphControlProps>({
  className: createReadableClass({
    component: 'fields',
    element: 'paragraph-control'
  })
})`
  word-wrap: break-word;
  font-size: ${({ _fontSize }) => _fontSize}px;
  color: ${({ _color }) => _color};
`;
